import { z } from "zod";
import { CLIP_VIDEO_DURATION_VALUES, GENERATION_FAILURE_REASON_VALUES, GENERATION_JOB_STATUS_VALUES, GENERATION_KIND_VALUES, GENERATION_TARGET_TYPE_VALUES, GenerationKind, } from "../../constants/generation.js";
import { GOLDEN_ASSET_KIND_VALUES } from "../../constants/golden-asset.js";
export const createGenerationSchema = z
    .object({
    kind: z.enum(GENERATION_KIND_VALUES),
    seriesId: z.uuid().optional(),
    storyId: z.uuid().optional(),
    targetType: z.enum(GENERATION_TARGET_TYPE_VALUES),
    targetId: z.uuid(),
    assetKind: z.enum(GOLDEN_ASSET_KIND_VALUES).optional(),
    videoDurationSeconds: z.union([z.literal(CLIP_VIDEO_DURATION_VALUES[0]), z.literal(CLIP_VIDEO_DURATION_VALUES[1])]).optional(),
})
    .refine((input) => input.kind !== GenerationKind.GOLDEN_ASSET || input.assetKind !== undefined, {
    message: "assetKind requis pour un golden asset",
});
export const retryGenerationSchema = z.object({
    failureReason: z.enum(GENERATION_FAILURE_REASON_VALUES),
});
export const GenerationJobSchema = z.object({
    id: z.uuid(),
    seriesId: z.uuid().nullable(),
    storyId: z.uuid().nullable(),
    kind: z.enum(GENERATION_KIND_VALUES),
    status: z.enum(GENERATION_JOB_STATUS_VALUES),
    targetType: z.enum(GENERATION_TARGET_TYPE_VALUES),
    targetId: z.uuid(),
    model: z.string(),
    prompt: z.string(),
    seed: z.number().int().nullable(),
    params: z.record(z.string(), z.unknown()).nullable(),
    costUsd: z.number().nullable(),
    durationMs: z.number().int().nullable(),
    attempt: z.number().int().positive(),
    parentJobId: z.uuid().nullable(),
    failureReason: z.enum(GENERATION_FAILURE_REASON_VALUES).nullable(),
    resultUrl: z.url().nullable(),
    error: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const GenerationJobListSchema = z.object({
    jobs: z.array(GenerationJobSchema),
});
